import { render } from "./BillItemComponent.vue?vue&type=template&id=637afd9f&scoped=true"
import script from "./BillItemComponent.vue?vue&type=script&lang=js"
export * from "./BillItemComponent.vue?vue&type=script&lang=js"

import "./BillItemComponent.vue?vue&type=style&index=0&id=637afd9f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637afd9f"]])

export default __exports__